/**
 * Per 2.2: the client calls ONE single base URL — the gateway. No scene or
 * panel ever constructs a Worker-specific URL directly. VITE_API_BASE
 * points at gateway-worker (or a custom domain sitting in front of it in
 * production), never at e.g. aetheria-player-worker.<account>.workers.dev.
 *
 * Per 2.11: game art is served from a dedicated CDN domain via
 * VITE_ASSET_CDN, backed by an R2 bucket + manifest.json.
 *
 * Deliberately a lazy getter (not a top-level throw at import time) so
 * this module can be imported in tests before env vars are stubbed.
 */
export interface ClientEnv {
  apiBase: string;
  assetCdn: string;
}

let cached: ClientEnv | null = null;

export function getEnv(): ClientEnv {
  if (cached) return cached;

  const apiBase = import.meta.env.VITE_API_BASE as string | undefined;
  const assetCdn = import.meta.env.VITE_ASSET_CDN as string | undefined;

  if (!apiBase) {
    throw new Error(
      "VITE_API_BASE is not set. The client must point at gateway-worker's single base URL (2.2)."
    );
  }
  if (!assetCdn) {
    throw new Error("VITE_ASSET_CDN is not set (2.11).");
  }

  cached = {
    apiBase: apiBase.replace(/\/+$/, ""),
    assetCdn: assetCdn.replace(/\/+$/, ""),
  };
  return cached;
}

/** Test-only escape hatch to reset the cache between test cases. */
export function __resetEnvCacheForTests(): void {
  cached = null;
}
